import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const NewsSummary = React.lazy(() =>
    import('../NewsSummary')
);
const newsSummaryRoutesRegistry = [
    {
        path: PAGE_URL.NEWS_SUMMARY_PAGE,
        element: <NewsSummary />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default newsSummaryRoutesRegistry;
